export default "__VITE_ASSET__Dy9cUuyn__"